import api from './axios';

export const getServiceSchedules = async () => {
  const response = await api.get('/service-schedules');
  return response.data;
};

export const updateServiceSchedule = async (id, data) => {
  const response = await api.put(`/service-schedules/${id}`, data);
  return response.data;
};

export const getServiceAlerts = async () => {
  const response = await api.get('/service-schedules/alerts');
  return response.data;
};
